export interface IPersistConfig {
  rootKey: string
}

export const persist: IPersistConfig = {
  rootKey: '_yf_persist'
}
